import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ServersComponent} from './servers.component';
import {ServersSummaryComponent} from './servers-summary/servers-summary.component';
import {ActionBarModule} from '../../components/action-bar/action-bar.module';
import {MaterialModule} from '../../material.module';
import {ArmTableModule} from '../../components/arm-table/arm-table.module';
import {LayoutModule} from '../../components/layout/layout.module';
import {LeadingZerosPipe} from './servers-summary/leading-zeros.pipe';
import {FlexModule} from '@angular/flex-layout';
import {ServerTypePipe} from './server-type.pipe';
import {ServerOperativeStatePipe} from './server-operative-state.pipe';
import { ServersDialogComponent } from './servers-dialog/servers-dialog.component';
import {DialogModule} from '../../components/dialog/dialog.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ArmFormTitleModule} from '../../components/arm-form/arm-form-title/arm-form-title.module';
import {InfraModule} from 'ac-infra';
import {ClientFilterModule} from '../../components/client-filter/client-filter.module';
import { LdapServerCertificateViewComponent } from './ldap-server-certificate-view/ldap-server-certificate-view.component';
import {ClipboardModule} from '@angular/cdk/clipboard';


@NgModule({
  declarations: [ServersComponent, ServersSummaryComponent,
    LeadingZerosPipe, ServerTypePipe, ServerOperativeStatePipe, ServersDialogComponent, LdapServerCertificateViewComponent
  ],
  exports: [LeadingZerosPipe],
  imports: [
    CommonModule,
    ActionBarModule,
    MaterialModule,
    ArmTableModule,
    LayoutModule,
    FlexModule,
    DialogModule,
    FormsModule,
    ArmFormTitleModule,
    ReactiveFormsModule,
    InfraModule,
    ClientFilterModule,
    ClipboardModule,
  ]
})
export class ServersModule {
}
